module.exports = __webpack_public_path__ + "img/tower.4486fe4f.png";